import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, NavLink } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { clearRoleType } from 'components/login/action';
import { logoutDispatcher } from 'components/login/dispatcher';

function Logout({ isUserProfile }) {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const handleLogout = (e) => {
    e.preventDefault();
    try {
      dispatch(logoutDispatcher());

      navigate('/auth/signin')
    } catch (error) {
      console.error('Logout failed:', error);

    }
  };

  return (

    <>
      {
        isUserProfile ? <>
          <span >Logout</span>
        </> : <>
          <div className="mt-auto mb-3" >
            <Button onClick={handleLogout} className='logout_btn' style={{ width: '100%', height: '40px', color: 'black' }}><i className="fa-solid fa-right-from-bracket"></i> Logout</Button>
          </div>
        </>
      }
    </>
  );
}

export default Logout;
